import { render, staticRenderFns } from "./SettingsPermissions.vue?vue&type=template&id=28546c08"
import script from "./SettingsPermissions.vue?vue&type=script&lang=js"
export * from "./SettingsPermissions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports